// modules/shared/helpers/loading-provider.helper.tsx
import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useCallback,
  useRef,
} from "react";

interface LoadingContextProps {
  loading: boolean;
  setLoading: (loading: boolean) => void;
  // Hỗ trợ loading với skeleton variant
  startLoading: (variant?: string, count?: number) => void;
  stopLoading: () => void;
  variant: string | null;
  count: number;
}

const LoadingContext = createContext<LoadingContextProps | undefined>(
  undefined,
);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false); // Mặc định false để tránh flash
  const [variant, setVariant] = useState<string | null>(null);
  const [count, setCount] = useState(3);
  const loadingStack = useRef(0);

  const startLoading = useCallback((v?: string, c = 3) => {
    loadingStack.current += 1;
    if (loadingStack.current === 1) {
      setVariant(v || null);
      setCount(c);
      setLoading(true);
    }
  }, []);

  const stopLoading = useCallback(() => {
    loadingStack.current = Math.max(0, loadingStack.current - 1);
    if (loadingStack.current === 0) {
      setLoading(false);
      setVariant(null);
    }
  }, []);

  return (
    <LoadingContext.Provider
      value={{
        loading,
        setLoading,
        startLoading,
        stopLoading,
        variant,
        count,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context)
    throw new Error("useLoading must be used within a LoadingProvider");
  return context;
};
